import Vue from 'vue'
import {UI_LANG} from "@utils/storageKeys";
import VueI18n from "vue-i18n"
import moment from "moment"
import 'moment/locale/el'

import el from '@/src/lang/el/index';
import en from '@/src/lang/en/index'

const messages = {
    el,
    en
}

Vue.use(VueI18n)

const locale = localStorage.getItem(UI_LANG) || 'el';

// Keep moment's global locale in lockstep with the UI locale. The explicit
// call matters: importing moment/locale/el alone silently flips the global
// locale to Greek even for 'en' users.
moment.locale(locale);

const i18n = new VueI18n({
    locale,
    messages
})
// VueI18n instance
export default i18n;
